import React from 'react'
import CustomModal from '../../../../Components/modals/CustomModal'

const ViewProfile = ({ show, close, profileUrl }) => {
    return (
        <CustomModal
            show={show}
            handleClose={close}
            className="input_image_model"
        >
            <img className='w-100' src={profileUrl} alt="" />
        </CustomModal>
    )
}

export default ViewProfile